import { useQuery } from '@tanstack/react-query';
import { trackingApi } from '@/lib/api';

export function useVisitors(params?: Parameters<typeof trackingApi.listVisitors>[0]) {
  return useQuery({
    queryKey: ['visitors', params],
    queryFn: () => trackingApi.listVisitors(params),
  });
}

export function useVisitorDetail(visitorId: string | undefined) {
  return useQuery({
    queryKey: ['visitors', visitorId],
    queryFn: () => trackingApi.getVisitor(visitorId!),
    enabled: !!visitorId,
  });
}

export function useContactPageViews(
  contactId: string | undefined,
  params?: { take?: number; skip?: number },
) {
  return useQuery({
    queryKey: ['pageViews', contactId, params],
    queryFn: () => trackingApi.getContactPageViews(contactId!, params),
    enabled: !!contactId,
  });
}
